import { all, AllEffect, ForkEffect, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import {
  GetUserPlayStatsAndLimitsAction,
  getUserPlayStatsAndLimitsError,
  getUserPlayStatsAndLimitsSuccess,
  UserPlayStatsAndLimitsActionType,
} from '../actions/userPlayStatsAndLimitsActions';
import BffApiService from '@/shared/bffApiService';

export function* getUserPlayStatsAndLimitsSaga(
  action: GetUserPlayStatsAndLimitsAction,
): SagaIterator {
  try {
    const response = yield call(BffApiService.getUserPlayStats, {
      config: { params: { months: action.months } },
    });
    yield put(getUserPlayStatsAndLimitsSuccess(response.data.data));
  } catch (error) {
    yield put(getUserPlayStatsAndLimitsError());
  }
}

export function* watchUserPlayStatsAndLimits(): Generator<AllEffect<ForkEffect<never>>, void> {
  yield all([
    takeEvery(
      UserPlayStatsAndLimitsActionType.GetUserPlayStatsAndLimits,
      getUserPlayStatsAndLimitsSaga,
    ),
  ]);
}
